module.exports = __webpack_public_path__ + "static/img/yinliang2.7da7135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/yinliang2.png
// module id = 1jc3
// module chunks = 24